import axios from 'axios';
import * as Sentry from '@sentry/react';
import * as appServices from './appServices';

export { appServices };

export const backendUrl = ``;

export const request = async (endpoint) => {
    try {
        const response = await axios.get(`${backendUrl}/api/${endpoint}`);
        if (response && response.data) {
            return response.data;
        }
    } catch (error) {
        Sentry.captureException(error);
        throw error;
    }
};

export const post = async (endpoint, data) => {
    try {
        const response = await axios.post(`/api/${endpoint}`, data);

        if (response && response.data) {
            return response.data;
        }
    } catch (error) {
        Sentry.captureException(error, (scope) => {
            scope.setContext('data', data);
            return scope;
        });
        throw error;
    }
};
